import { gql } from '@apollo/client';

export const GET_PROXY_URL_QUERY = gql`
    query proxyObject( $proxyObjectID: UUID! ) {
        proxyObject( proxyObjectID: $proxyObjectID ) {
            id
            fieldData
            companyIntegration {
            id
            integrationType{
                id
                name
                description
                key
                configurationSchema
                fieldSchema 
                }
            }
        }
    } 
`;
